export default "__VITE_ASSET__CxEQ1MBD__"